import React from 'react';
import { ConfirmModal, useModalContext } from '@fourthwall/components';
import { DomainString } from '../DomainString/DomainString';
import * as S from './ConfirmClaimDomainModal.styled';
export const ConfirmClaimDomainModal = ({ domain, onConfirm }) => {
    const { close } = useModalContext();
    return (React.createElement(ConfirmModal, { title: "Claim domain", size: "medium", text: React.createElement(S.Content, null,
            React.createElement("div", null, "You're about to claim your free Pro domain:"),
            React.createElement(S.DomainName, null,
                React.createElement(DomainString, { domain: domain })),
            React.createElement(S.Description, null, "Once claimed, this domain will be associated with your Fourthwall account and can be used for your site. This action cannot be reversed.")), confirmLabel: "Claim domain", onConfirm: onConfirm, onCancel: close, close: close }));
};
